import React, { useRef } from 'react';
import { Box, Divider } from '@mui/material';
import {
  FormProps,
  FormHeader,
  ClientNameField,
  DocumentUploadArea,
  FactsDescriptionField,
  PieceToRebutField,
  AudioRecordingSection,
  WritingStyleSelector,
  InfoTip,
} from './shared';

// Opções para recurso especial
const PECAS_RECORRIDAS = [
  'Acórdão',
  'Acórdão em Apelação',
  'Acórdão em Agravo de Instrumento',
  'Acórdão em Embargos de Declaração',
  'Acórdão em Mandado de Segurança',
  'Outro'
];

const RecursoEspecialForm: React.FC<FormProps> = ({
  documentType,
  values,
  onChange,
  uploadedFiles,
  onFileUpload,
  onFileRemove,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [selectedStyle, setSelectedStyle] = React.useState(values.estilo_escrita || 'padrao');

  const handleFieldChange = (fieldId: string, value: any) => {
    onChange({
      ...values,
      [fieldId]: value,
    });
  };

  const handleRecordingComplete = (audioBlob: Blob) => {
    const audioFile = new File([audioBlob], `audio_${Date.now()}.webm`, {
      type: 'audio/webm',
    });
    onFileUpload([audioFile]);
  };

  return (
    <Box>
      <FormHeader 
        documentType={documentType}
        customTitle="Recurso Especial"
        customDescription="Recurso ao Superior Tribunal de Justiça por violação à lei federal"
      />

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {/* 1. Nome do Cliente */}
        <ClientNameField
          value={values.nome_cliente || ''}
          onChange={(value) => handleFieldChange('nome_cliente', value)}
        />

        {/* 2. Upload de Documentos */}
        <DocumentUploadArea
          uploadedFiles={uploadedFiles}
          onFileUpload={onFileUpload}
          onFileRemove={onFileRemove}
          suggestedDocs="Acórdão e Processo na íntegra."
          fileInputRef={fileInputRef as React.RefObject<HTMLInputElement>}
        />

        {/* 3. Descrição dos Fatos (Opcional) */}
        <FactsDescriptionField
          value={values.fatos_caso || ''}
          onChange={(value) => handleFieldChange('fatos_caso', value)}
          placeholder="Descreva a violação à lei federal, divergência jurisprudencial, dispositivos legais violados..."
        />

        {/* 4. Decisão recorrida */}
        <PieceToRebutField
          value={values.peca_rebater || 'Acórdão'}
          onChange={(value) => handleFieldChange('peca_rebater', value)}
          otherValue={values.peca_rebater_outro || ''}
          onOtherChange={(value) => handleFieldChange('peca_rebater_outro', value)}
          options={PECAS_RECORRIDAS}
          label="Indique a peça do processo que deseja rebater ou responder:"
        />

        {/* Gravação de Áudio */}
        <AudioRecordingSection
          onRecordingComplete={handleRecordingComplete}
          description="Grave um áudio descrevendo os fundamentos do recurso que a IA irá transcrever automaticamente."
        />
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Estilo de Escrita */}
      <WritingStyleSelector
        selectedStyle={selectedStyle}
        onStyleChange={(styleId) => {
          setSelectedStyle(styleId);
          handleFieldChange('estilo_escrita', styleId);
        }}
      />

      <InfoTip message="Anexe obrigatoriamente o acórdão recorrido para que a IA possa identificar as violações à lei federal e fundamentar adequadamente o recurso especial." />
    </Box>
  );
};

export default RecursoEspecialForm;

